import './avatar.css';
import template from './avatar.tpl.html';

export const avatar = {
    bindings: {
        cdsid: '<',
        admin: '<',
        version: '<'
    },
    template
};
